import { ACCOUNT_TRACKING_EVENTS } from 'features/account/constants'
import { TrackEvent } from 'features/account/hooks/useTrackAccountClickEvent'

import { News } from '../duck/types'

export interface NewsTeaser {
  imageUrlLarge: string
  imageUrlMedium: string
  imageUrlSmall: string
  imageAltText: string
  headline: string
  preamble: string
  linkUrl: string
  onTeaserClick?(): void
  target?: '_blank' | '_self' | '_parent' | '_top' | string
  classes?: Partial<{
    headline: string
  }>
}

interface NewsTeaserProps {
  news: News
  trackEvent: TrackEvent
  headlineClassName?: string
}

const getImageNewsLink = (news: News): string => {
  if (news.thumbnailImageLink) {
    return news.thumbnailImageLink
  }

  if (news.altImageLink) {
    return news.altImageLink
  }

  return news.imageLink
}

export const createNewsTeaser = ({
  news,
  trackEvent,
  headlineClassName,
}: NewsTeaserProps): NewsTeaser => {
  const imageUrl = getImageNewsLink(news)

  return {
    imageUrlLarge: imageUrl,
    imageUrlMedium: imageUrl,
    imageUrlSmall: imageUrl,
    imageAltText: news.pageTitle,
    headline: news.pageTitle,
    preamble: news.pageDescription,
    linkUrl: news.pagePath,
    onTeaserClick: () => {
      trackEvent({ ...ACCOUNT_TRACKING_EVENTS.onNewsClick, eventLabel: news.pageTitle })()
    },
    target: '_blank',
    classes: {
      headline: headlineClassName,
    },
  }
}
